    import 'core-js';
    import 'regenerator-runtime/runtime';

    /*
    * AOS.
    * */
    import "aos/dist/aos.css";

    import AOS from "aos";

    AOS.init({
        startEvent: "load",
        once: false,
        delay: 100,
        offset: 0,
        disable: function() {
            return window.innerWidth <= 991;
        },
    });

    import "./plugins/aos";

    /*
    * Accordion.
    * */
    import {accordion} from './components/accordion';
    accordion();

    /*
    * Tables.
    * */
    import {tableDataMobileLabels} from './components/tables';
    tableDataMobileLabels();


    /*
    * Tabs.
    * */
    import 'bootstrap/js/dist/util';
    // import "bootstrap/scss/_nav.scss";
    import 'bootstrap/js/dist/tab';
    import 'bootstrap/js/dist/dropdown';

    /*
    * Dropdown.
    * */
    // import './vendor/bs-dropdown';

    import 'jquery-match-height';
    $(function() {
        $(document).ready(function(){
            $('.js-c-item__label').matchHeight();
        });
    });

    /*
    * Box Building Sensors - Sorting.
    * */
    import {sensorsSorting} from './boxes/box-building-sensors';
    sensorsSorting(
        '.c-sensors',
        '.c-box-building-sensors .c-dropdown__menu'
    );
    sensorsSorting(
        '.c-box-devices__list',
        '.c-box-devices .c-dropdown__menu'
    );
    sensorsSorting(
        '.c-box-control-points__list',
        '.c-box__header-menu--control-points-types .c-dropdown__menu'
    );

    /*
    * Top User Menu.
    * */
    import {topUserMenu} from './components/top-user-menu';
    topUserMenu()

    /*
    * Box Building Statistics.
    * */
    import './boxes/box-building-stats';

    /*
    * Box Building History Statistics.
    * this one seems to be only used in the following template:
    * /views/buildingDetails/_box-stats-history.gsp
    * */

    // import './boxes/box-building-history-stats';

    /*
    * Box Forecast Hours Chart.
    * */
    import './boxes/box-forecast-hours-chart';

    /*
    * Box Forecast Week Chart.
    * */
    import './boxes/box-forecast-week-chart';

    /*
    * Box Forecast Changes Charts.
    * */
    import './boxes/box-forecast-changes-charts';

    /*
    * Box Weather.
    * */
    import './boxes/box-weather';
    boxWeather();

    /*
    * Box Menu.
    * */
    import {boxMenu} from './components/boxMenu';
    boxMenu('.c-box-menu__switcher');

    /*
    * Box Menu - Default Mobile Closing.
    * */
    import {boxMenuMobile} from './components/boxMenuMobile';
    boxMenuMobile();

    /*
    * Sticky Header
    * */
    import {stickyHeader} from './components/sticky-header';
    stickyHeader();

    /*
    * Submenu Mobile.
    * */
    import {submenuMobile} from './components/submenu-mobile';
    submenuMobile();

    /*
    * GLightBox.
    * */
    import { gLightBoxSettings } from './plugins/glightbox';
    gLightBoxSettings();

    /*
    * Tabs Scroll Center.
    * */
    import {tabsScrollCenter} from './components/tabsScrollCenter';
    import {all} from 'mmenu-js/dist/_modules/i18n';

    // Scroll tabs in History Stats Box.
    tabsScrollCenter('.c-box-stats-history__tabs .active');

    /*
    * Open Tab by Url Hash.
    * */
    import {tabOpenByUrl} from './components/tabOpenByUrl';
    tabOpenByUrl();

    /*
    * Open Tab by click link.
    * */
    import {tabOpenByClick} from './components/tabOpenByClick';
    tabOpenByClick();

    /*
    * Images Carousel.
    * */
    /*
    * Import slick lib.
    * */
    import 'slick-carousel/slick/slick.css';
    import 'slick-carousel/slick/slick.js';

    /*
    * Styles.
    * */
    // import './_logos-styles.scss';
    import {imagesCarousel} from './components/imageCarousel';
    imagesCarousel();

    /**
     *  Global Event bus init & subscriptions
     */
    import {registerGlobalSubscribers} from './components/globalEvents';
    registerGlobalSubscribers();

    import * as GlobalEvents from './components/globalEvents';
    import {boxWeather} from './boxes/box-weather';
    import {boxForecast48} from './boxes/box-forecast48';

    window.GlobalEvents = new GlobalEvents.GlobalEvents();

    import {mainDashboard} from './components/mainDashboard';
    mainDashboard();

    import {notificationsBox} from './components/notificationsBox';
    notificationsBox();

    window.reloadListeners = () => {
        mainDashboard();
        boxMenu('#dashboard-locations .c-box-menu__switcher');
        boxMenuMobile();
        accordion();
    };
